import { action } from 'easy-peasy';
import { IActionSetActTeamMember } from '../types';

const setActTeamMember: IActionSetActTeamMember = action((state, payload) => {
  state.current = payload;
});

export default setActTeamMember;
